module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAADCAYAAACwAX77AAAAK0lEQVQYV2P8//9/CgMDQw8QI4NiRhAPKFmEJFnEyMg4ASyBJPkPJAjiAwA4JQ5kq2QfIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/d.png
// module id = VKIn
// module chunks = 15